export const SUPPLIER_IMAGE_WIDTH_RATIO = 267;
export const SUPPLIER_IMAGE_HEIGHT_RATIO = 170;
export const SUPPLIER_IMAGE_ASPECT_RATIO = SUPPLIER_IMAGE_WIDTH_RATIO / SUPPLIER_IMAGE_HEIGHT_RATIO;
export const SUPPLIER_IMAGE_CSS_RATIO = `${SUPPLIER_IMAGE_WIDTH_RATIO} / ${SUPPLIER_IMAGE_HEIGHT_RATIO}`;
export const SUPPLIER_IMAGE_DEFAULT = "/images/ciao_stiro.png";

// Match the backend's orientation normalization, without changing the stored original.
export function supplierOriginalPreview(url) {
  return url?.replace(/(\/image\/upload\/)(v\d+\/)/, "$1a_auto/f_png/$2") || "";
}

export function cropGeometry(image, zoom, position) {
  const width = Math.min(image.width, image.height * SUPPLIER_IMAGE_ASPECT_RATIO) / zoom;
  const height = width / SUPPLIER_IMAGE_ASPECT_RATIO;
  return {
    x: (image.width - width) * position.x / image.width,
    y: (image.height - height) * position.y / image.height,
    width: width / image.width, height: height / image.height,
  };
}
